import { IGameAttendances, defaultPointsBreakDown, pointsTypeMapper } from "@grassrootly/api";
import { Div, Label, Icon, Touchable } from "@grassrootly/rn-core";
import React from "react";
import { Image, LayoutAnimation } from "react-native";
import { GamePlayerProps } from "./GameAttendees.types";
import { images } from "../../../layout/assets";
import { PlayerRating } from "../../shared";

export default function Player({ attendee, showTeam = false, showPoints = false }: GamePlayerProps) {
  const [isExpanded, setIsExpanded] = React.useState(false);
  const onPress = () => {
    LayoutAnimation.configureNext(LayoutAnimation.Presets.easeInEaseOut);
    setIsExpanded(!isExpanded);
  };
  return (
    <Div classNames={["flex1"]}>
      <Touchable
        classNames={["flexRow", "alignItemsCenter"]}
        onPress={onPress}
        touchedOpacity={0.9}
        disabled={!showPoints}
      >
        <Image
          style={{ height: 40, width: 40, borderRadius: 40 }}
          resizeMode="cover"
          source={attendee.player?.profile_picture ? { uri: attendee.player?.profile_picture } : images.playerAvatar}
        />
        <Div classNames={["ml-{15}", "flex1"]}>
          <Label numberOfLines={1} ellipsizeMode="tail">
            {attendee.player?.name}
            {attendee.team && showTeam ? ` (${attendee.team == "HOST" ? "Beli" : "Markeri"})` : ""}
          </Label>
          <Div classNames={["flexRow", "mt-{8}", "gap8"]}>
            {attendee.goals_scored ? (
              <Div classNames={["flexRow", "alignContentCenter", "justifyContentCenter"]}>
                <Icon name="sports_soccer" classNames={["mr-{2}"]} size={18} />
                <Label type="l3Regular">{attendee.goals_scored > 1 ? `x${attendee.goals_scored}` : ""}</Label>
              </Div>
            ) : null}
            {attendee.assists_made ? (
              <Div classNames={["flexRow", "alignContentCenter", "justifyContentCenter"]}>
                <Image source={images.assist} style={{ marginRight: 3, height: 14, width: 24 }} />
                <Label type="l3Regular">{attendee.assists_made > 1 ? `x${attendee.assists_made}` : ""}</Label>
              </Div>
            ) : null}
          </Div>
        </Div>
        {showPoints ? (
          <Div classNames={["ml-{auto}", "flexRow", "alignContentCenter", "justifyContentCenter"]}>
            <Div>
              {typeof attendee.rating == "number" ? (
                <PlayerRating rating={attendee.rating} classNames={["mb-{3}", "ml-{auto}"]} />
              ) : null}
              <Label type="l3Regular">Exp +{attendee.points_earned}</Label>
            </Div>
            <Icon
              name={isExpanded ? "keyboard_arrow_up" : "keyboard_arrow_down"}
              classNames={["ml-{8}", "mv-{auto}"]}
            />
          </Div>
        ) : null}
      </Touchable>
      {isExpanded ? (
        <Div classNames={["pt-{12}", "ml-{55}", "flexRow", "alignContentCenter"]}>
          <Div classNames={["mr-{24}"]}>
            {(attendee.points_earned_breakdown || defaultPointsBreakDown).map((category, i) => {
              console.log(category);
              return (
                <Label key={i} type="l2Regular" classNames={["mb-{4}"]}>
                  {pointsTypeMapper[category.type]}
                </Label>
              );
            })}
          </Div>
          <Div classNames={["ml-{auto}", "mr-{24}"]}>
            {(attendee.points_earned_breakdown || defaultPointsBreakDown).map((category, i) => (
              <Label key={i} type="l2Regular" classNames={["mb-{4}", "textLeft"]}>
                {category.type === "game_rating" ? category.total : `${category.total} pts`}
              </Label>
            ))}
          </Div>
        </Div>
      ) : null}
    </Div>
  );
}
